module.exports = __webpack_public_path__ + "static/media/background.fragment.9d0a16f5.glsl";